import * as queryString from 'x-query-string';

import { ProcessPaymentRequest } from '@cashier/cashier-api-model';
import { IntegrationSources } from '@cashier/cashier-model';

export const convertToProcessRequestBody = ({
  paymentType,
  paymentMethodId,
  userId,
  sessionId,
  vendor,
  merchantId,
  paymentAttributes,
  referenceId,
  callbackParameterBag,
  source,
}: ProcessPaymentRequest): object => {
  const { bonusCode, orderId, ...paymentAttributesWithoutBonusCodeAndOrderId } =
    paymentAttributes;

  const { accountId, ...paymentAttributesWithoutAccountId } = paymentAttributes;

  const redirectHost = window.location.origin;
  const redirectQueryString = queryString.encode(callbackParameterBag);

  const requestData = {
    [IntegrationSources.Internal]: {
      type: paymentType,
      paymentMethodId,
      userId,
      sessionId,
      paymentAttributes: paymentAttributesWithoutBonusCodeAndOrderId,
      merchantId,
      referenceId,
      attributes: {
        bonusCode,
        orderId,
      },
      successRedirectUrl: `${redirectHost}/success?${redirectQueryString}`,
      failureRedirectUrl: `${redirectHost}/failure?${redirectQueryString}`,
    },
    [IntegrationSources.External]: {
      type: paymentType,
      walletId: userId,
      sessionId,
      merchantId,
      referenceId,
      returnUrl: `${redirectHost}/confirm?${redirectQueryString}`,
      payment: {
        accountId: accountId || null,
        methodId: paymentMethodId,
        serviceId: vendor,
        attributes: paymentAttributesWithoutAccountId,
      },
    },
  };

  return requestData[source];
};
